<!-- 时间组件 -->
<template>
  <div class="block">
    <el-date-picker
      v-model="times[0]"
      type="date"
      value-format="yyyy-MM-dd"
      :picker-options="beginPickerOptions"
      @change="emit"
      :clearable="false"
      :editable="false"
      placeholder="开始时间"
    ></el-date-picker>
    <span>&nbsp;-&nbsp;</span>
    <el-date-picker
      v-model="times[1]"
      type="date"
      :picker-options="pickerOptions"
      :clearable="false"
      :editable="false"
      value-format="yyyy-MM-dd"
      @change="emit"
      placeholder="结束时间"
    ></el-date-picker>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
     mixins: [minxin],
  data() {
    return {
      times: [new Date().getTime(), new Date().getTime()],
      placeholder: ["开始日期", "结束日期"]
    };
  },
  components: {},
  computed: {
    beginPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      };
    },
    pickerOptions() {
      // pickerOptions
      let _this = this;
      return {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() - 8.64e6
            // Date.now() < time.getTime() < new Date(_this.times[0]).getTime()
          );
        }
      };
    }
  },
  created() {
    if (this.$route.query.beginTime != undefined) {
      this.times = [
        new Date(this.$route.query.beginTime),
        new Date(this.$route.query.endTime)
      ];
    } else {
      this.times[0] = this.formatDay(new Date().getTime() - 24 * 60 * 60 *1000)
      this.times[1] = this.times[0];
      // this.times = [new Date(), new Date()];
    }

    this.emit();
  },
  // activated(){
  //     this.emit();
  // },
  methods: {
    isEariy() {
      return this.times[0];
    },
    emit() {
      this.pickerOptions;
      if (new Date(this.times[0]).getTime() > new Date(this.times[1]).getTime()) {
        this.$message.warning("开始时间不能大于结束时间");
      } else {
        this.$emit("time", this.times);
      }
    }
  }
};
</script>
<style lang='less' scoped>
/deep/.el-date-editor.el-input,
/deep/ .el-date-editor.el-input__inner {
  // width: 220px;
  width: 150px;
  height: 32px;
}
/deep/ .el-input__inner {
  height: 32px;
}
/deep/.el-input__icon {
  line-height: 32px;
}
</style>